import { Button, Table } from "antd";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const IncomeTable = ({ allExpenses = [] }) => { // Default to empty array if undefined
  const [data, setData] = useState([]);
  const [showAll, setShowAll] = useState(false); // State to manage view mode

  useEffect(() => {
    setData(allExpenses);
  }, [allExpenses]); // Ensure data updates when allExpenses changes

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
  ];

  // Determine the data to be displayed based on the showAll state
  // const displayData = showAll ? data : data.slice(0, 5);

  return (
    <div className="col-md-12 d-flex">
      <div className="card card-table flex-fill">
        <div className="card-header">
          <h3 className="card-title mb-0">Expenses</h3>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <Table
              dataSource={data}
              columns={columns}
              pagination={false}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
        <div className="card-footer">
        </div>
      </div>
    </div>
  );
};

export default IncomeTable;
